import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
import { enableProdMode } from '@angular/core';
// Forzamos el modo producción para apagar los mensajes de consola de Angular
enableProdMode();

bootstrapApplication(AppComponent, appConfig)
  .catch((err) => console.error(err));
